import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LoginService } from '../../../services/authentication/login.service';
declare var $: any;

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ApiService } from 'src/app/services/main/api.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/authentication/auth.service';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  permissions = [];

  constructor(public router: Router, public srv: LoginService, public apiService: ApiService, public authService: AuthService) {
    this.version = environment.version;
  }

  tabStatus = 'justified';
  version:any;
  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = true;
  public UserlogName = true;
  ViewIconNotify:boolean

  options = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // fixed value. shouldn't be changed.
    sidebartype: 'iconbar', // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin2', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin6', // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin6' // six possible values: skin(1/2/3/4/5/6)
  };

  Logo() {
    this.expandLogo = !this.expandLogo;
    this.UserlogName = !this.UserlogName;
  }

  ngOnInit() {
      if (this.router.url === '/comex') {
        this.router.navigate(['/comex/purchase']);
      }
      this.defaultSidebar = this.options.sidebartype;
      this.handleSidebar();

      this.srv.getPermissions().then(x => {
          this.permissions = x;
      });

      this.router.events.subscribe((val) => {
          if( val instanceof NavigationEnd ){
              this.showMobileMenu = false;
          }
      });

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleSidebar();
  }

  handleSidebar() {
      this.innerWidth = window.innerWidth;
      //console.log(this.defaultSidebar);
      switch (this.defaultSidebar) {
        case 'full':
        case 'iconbar':
          //if (this.innerWidth < 1170) {
          if (this.innerWidth < 768) {
            this.expandLogo = true;
            this.UserlogName = true;
            this.ViewIconNotify=true;
            this.options.sidebartype = 'mini-sidebar';
          }
          //else if (this.innerWidth < 767) {
          else if (this.innerWidth < 1170) {
            this.expandLogo = false;
            this.UserlogName = false;
            this.options.sidebartype = 'mini-sidebar';
          }
          else {
            this.expandLogo = true;
            this.UserlogName = false;
            this.ViewIconNotify=false;
            this.options.sidebartype = this.defaultSidebar;
          }
        break;

        case 'overlay':
          this.expandLogo = true;
          if (this.innerWidth < 767) {
            this.options.sidebartype = 'mini-sidebar';
          } else {
            this.options.sidebartype = this.defaultSidebar;
          }
        break;

        default:
      }
      // console.log(this.options.sidebartype);
  }

  toggleSidebarType() {
    this.Logo();

    switch (this.options.sidebartype) {
      case 'full':
      case 'iconbar':
        this.options.sidebartype = 'mini-sidebar';
        break;

      case 'overlay':
        this.showMobileMenu = !this.showMobileMenu;
        break;

      case 'mini-sidebar':
        if (this.defaultSidebar === 'mini-sidebar') {
          this.options.sidebartype = 'full';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  hasPermission(str:string){
      if( this.permissions.indexOf(str) > -1 ){
          return true;
      }
      else{
          return false;
      }
  }

}
